module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "calc(100%)"
    }
  }, [_c('user-client-typeahead', {
    on: {
      "onHit": _vm.onHitTypeahead,
      "onSearch": _vm.onClickCancel,
      "onClickNew": _vm.onClickNew
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.userClient.id > 0)),
      expression: "!(userClient.id > 0)"
    }],
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickNew
    }
  }, [_vm._v("\n        Mitarbeiter - Abteilung - Thema anlegen\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userClient.id),
      expression: "!userClient.id"
    }]
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.userClientHistory.length < 2,
      "title": _vm.historyTitle
    },
    on: {
      "click": _vm.onClickHistoryBack
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userClient.id > 0),
      expression: "userClient.id > 0"
    }],
    staticClass: "user-client",
    staticStyle: {
      "height": "calc(100% - 55px)"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #CCC"
    }
  }, [_c('h2', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.userClientHistory.length < 2,
      "title": _vm.historyTitle
    },
    on: {
      "click": _vm.onClickHistoryBack
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "fa",
    class: _vm.typeIconClass,
    staticStyle: {
      "color": "purple"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.sexText)
    }
  }), _vm._v("\n         " + _vm._s(_vm.userClient.firstName) + " " + _vm._s(_vm.userClient.lastName) + " - \n        "), _c('small', [_vm._v(_vm._s(_vm.userClient.department) + ", " + _vm._s(_vm.userClient.function) + ", " + _vm._s(_vm.userClient.room) + " ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: ('{intern::' + _vm.userClient.id + '::' + _vm.userClient.firstName + ' ' + _vm.userClient.lastName + ' ' + _vm.userClient.department + ' ' + _vm.userClient.function+'}'),
      expression: "'{intern::' + userClient.id + '::' + userClient.firstName + ' ' + userClient.lastName + ' ' + userClient.department + ' ' + userClient.function + '}'",
      arg: "copy"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Kopiere Link in Zwischenablage"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "title": "bearbeiten"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash",
    attrs: {
      "title": "ausblenden"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userClient.calltemplate),
      expression: "userClient.calltemplate"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Vorlage in Nachricht einfügen"
    },
    on: {
      "click": _vm.onClickAddTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "calc(100% - 55px)"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "border-right": "1px solid #CCC",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-memo-list"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "user-client-memo-accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, _vm._l((_vm.memos), function(memo, index) {
    return _c('cc-memo', {
      key: memo.id,
      staticClass: "panel cc-panel-default cc-memo-item",
      attrs: {
        "collapseIn": _vm.isMemoCollapse(index),
        "data_parent": 'xuser-client-memo-accordion',
        "memo": memo
      },
      on: {
        "remove": _vm.onRemoveMemo,
        "update": _vm.onSetMemo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.memos.length),
      expression: "!memos.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine Vorgaben")]), _vm._v(" "), (_vm.userClient.id > 0 && _vm.idCompanyClient > 0) ? _c('cc-memo', {
    staticClass: "cc-kombox-item",
    attrs: {
      "idCompany": 0,
      "idUser": _vm.userClient.id
    },
    on: {
      "insert": _vm.onAddMemo
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-kombox-list"
  }, [_vm._l((_vm.komboxes), function(kombox) {
    return _c('cc-kombox', {
      key: kombox.id,
      staticClass: "cc-kombox-item",
      attrs: {
        "kombox": kombox
      },
      on: {
        "add-shipping": _vm.onKomboxAddShipping,
        "remove-shipping": _vm.onKomboxRemoveShipping,
        "remove": _vm.onRemoveKombox,
        "update": _vm.onSetKombox
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.komboxes.length),
      expression: "!komboxes.length"
    }],
    staticClass: "alert alert-warning text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n              Keine Komboxen\n            ")]), _vm._v(" "), (_vm.userClient.id > 0 && _vm.idCompanyClient > 0) ? _c('cc-kombox', {
    staticClass: "cc-kombox-item",
    attrs: {
      "idCompany": _vm.idCompanyClient,
      "idUser": _vm.userClient.id
    },
    on: {
      "insert": _vm.onAddKombox
    }
  }) : _vm._e()], 2)])])])], 1), _vm._v(" "), (_vm.editModus == 'edit') ? _c('cc-user-client-modal', {
    attrs: {
      "userClient": _vm.userClient
    },
    on: {
      "cancel": function($event) {
        _vm.editModus = false
      },
      "save": _vm.saveUserClient
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editModus == 'new') ? _c('cc-user-client-modal', {
    attrs: {
      "idCompanyClient": _vm.idCompanyClient
    },
    on: {
      "cancel": function($event) {
        _vm.editModus = false
      },
      "save": _vm.saveUserClient
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69912a19!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserClient.vue
// module id = 281
// module chunks = 0